import { createContext, useContext, useState, ReactNode } from 'react';

interface AppContextModel {
  username?: string;
  setUsername: (value: string | undefined) => void;
  isStaff?: boolean;
  setIsStaff: (value: boolean | undefined) => void;
  isSuperuser?: boolean;
  setIsSuperuser: (value: boolean | undefined) => void;
  geoPolygon?: number[][];
  setGeoPolygon: (value: number[][] | undefined) => void;
}

const AppContext = createContext<AppContextModel | undefined>(undefined);

interface AppContextProviderProps {
  children: ReactNode;
  initialUsername?: string;
  initialIsStaff?: boolean;
  initialIsSuperuser?: boolean;
}

export const AppContextProvider = ({
  children,
  initialUsername,
  initialIsStaff,
  initialIsSuperuser,
}: AppContextProviderProps) => {
  const [username, setUsername] = useState<string | undefined>(initialUsername);
  // add user role such as staff and superuser to context
  const [isStaff, setIsStaff] = useState<boolean | undefined>(initialIsStaff);
  const [isSuperuser, setIsSuperuser] = useState<boolean | undefined>(
    initialIsSuperuser,
  );
  const [geoPolygon, setGeoPolygon] = useState<number[][]>();

  return (
    <AppContext.Provider
      value={{
        username,
        setUsername,
        isStaff,
        setIsStaff,
        isSuperuser,
        setIsSuperuser,
        geoPolygon,
        setGeoPolygon,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppContextProvider');
  }
  return context;
};
